import { useMediaQuery as measureScreenWidth } from "@mui/material";
import {
  DatePickerProps,
  DesktopDatePicker as DesktopBase,
  MobileDatePicker as MobileBase,
} from "@mui/x-date-pickers";
import { useState } from "react";
import { belowLargeTablet } from "./responsiveHelpers";
import { inferDateFormat } from "./timeFormats";
import withController from "./withController";

type ManagedProps = "defaultValue" | "sx" | "open";
export type DateInputProps = Omit<DatePickerProps, ManagedProps> & {
  autoComplete?: string;
  onChange: Required<DatePickerProps>["onChange"];
  value: Required<DatePickerProps>["value"];
  error?: boolean;
  label: string;
  helperText?: string;
};

export function DateInputBase({
  value,
  error,
  helperText,
  autoComplete,
  ...rest
}: DateInputProps) {
  const [open, setOpen] = useState(false);
  const isMobileOrSmallTablet = belowLargeTablet(measureScreenWidth);
  const onOpen = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  /* This format has to be adapted to this specific locale */
  const dateFormat = inferDateFormat()
    .replace(/-/gi, "/")
    .replace("DD", "dd")
    .replace("YYYY", "yyyy");

  if (isMobileOrSmallTablet) {
    return (
      <MobileBase
        {...rest}
        value={value || null}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        format={dateFormat}
        slotProps={{
          field: {
            openPickerButtonPosition: "end",
          },
          textField: {
            onClick: onOpen,
            slotProps: { htmlInput: { autoComplete } },
            sx: { width: 1 },
            error: error,
            helperText: helperText,
          },
        }}
      />
    );
  }
  return (
    <DesktopBase
      {...rest}
      value={value || null}
      format={dateFormat}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      slotProps={{
        field: {
          openPickerButtonPosition: "end",
        },
        textField: {
          onClick: onOpen,
          slotProps: { htmlInput: { autoComplete } },
          sx: { width: 1 },
          error: error,
          helperText: helperText,
        },
      }}
    />
  );
}

export default withController(DateInputBase);
